import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Rosa',
  city: 'Córdoba'
}, {
  name: 'Carla',
  city: 'Rosario'
}, {
  name: 'Ana',
  city: 'Mendoza'
}, {
  name: 'Lucía',
  city: 'Salta'
}, {
  name: 'Julieta',
  city: 'Tucumán'
}, {
  name: 'Gabriela',
  city: 'La Plata'
}, {
  name: 'Sandra',
  city: 'Mar del Plata'
}, {
  name: 'Elena',
  city: 'Santa Fe'
}, {
  name: 'Daniela',
  city: 'Neuquén'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 10000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-3 pr-6 flex items-center gap-3 max-w-[300px] animate-popup-in" style={{
    animation: 'popup-in 0.4s ease-out forwards'
  }} data-id="element-244">
      <div className="bg-green-100 p-1.5 rounded-full" data-id="element-245">
        <CheckCircle2 size={20} className="text-green-600" data-id="element-246" />
      </div>
      <div data-id="element-247">
        <p className="text-sm text-gray-800 leading-tight" data-id="element-248">
          <span className="font-bold" data-id="element-249">{currentBuyer.name}</span> de{' '}
          {currentBuyer.city}
        </p>
        <p className="text-xs text-gray-500 mt-0.5" data-id="element-250">
          acaba de comprar este sistema
        </p>
      </div>
      <style data-id="element-251">{`
        @keyframes popup-in {
          from { opacity: 0; transform: translateY(20px) scale(0.95); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>;
}